import * as React from "react";
import { AccountNextStep, ServiceProviderType } from "@/types";
import { RadioGroupInput } from "@/components/atoms";
type RadioGroupInputType = { value: AccountNextStep, label: React.ReactNode | string };

type AccountNextStepInputProps = {
  serviceProviderType: ServiceProviderType;
  value?: string;
  error?: string;
  onValueChange: (value: string) => void;
  fields?: ReadonlyArray<RadioGroupInputType>
};

export const AccountNextStepInput: React.FC<AccountNextStepInputProps> = ({
  serviceProviderType,
  value,
  error,
  onValueChange, fields
}) => {
  return (
    <RadioGroupInput
      onValueChange={onValueChange}
      value={value}
      fields={fields || fieldsFor(serviceProviderType)}
      error={error}
    />
  );
};

const fieldsFor = (serviceProviderType?: ServiceProviderType) => {
  switch (serviceProviderType) {
    case ServiceProviderType.Insurance:
    case ServiceProviderType.Pension:
      return insuranceFields;

    case ServiceProviderType.Broadband:
    case ServiceProviderType.Telecoms:
    case ServiceProviderType.TV:
      return telecomsFields;

    case ServiceProviderType.Mobile:
      return mobileFields;

    default:
      return defaultFields;
  }
};

const defaultFields = [
  { value: AccountNextStep.Cancel, label: "Close the account" },
  {
    value: AccountNextStep.UpdateAccountHolder,
    label: "Update primary account holder",
  },
];

const insuranceFields = [
  { value: AccountNextStep.Cancel, label: "Close the policy" },
  {
    value: AccountNextStep.UpdateAccountHolder,
    label: "Update policy holder",
  },
];

const telecomsFields = [
  { value: AccountNextStep.Cancel, label: "Close the account" },
  { value: AccountNextStep.UpdateAccountHolder, label: "Transfer the account" },
];

const mobileFields = [
  { value: AccountNextStep.Cancel, label: "Close the account" },
  { value: AccountNextStep.UpdateAccountHolder, label: "Transfer the account" },
  { value: AccountNextStep.MoveToPayAsYouGo, label: "Move to Pay as you go" },
  { value: AccountNextStep.MoveToAnotherService, label: "Move to another mobile network" },
];

